var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContempt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.3728 0 0 5.49065 0 12.2632C0 19.0358 5.3728 24.5264 12 24.5264C18.6272 24.5264 24 19.0358 24 12.2632C24 5.49065 18.6272 0 12 0ZM12 23.5045C5.9344 23.5045 1 18.4619 1 12.2632C1 6.06457 5.9344 1.02193 12 1.02193C18.0656 1.02193 23 6.06457 23 12.2632C23 18.4619 18.0656 23.5045 12 23.5045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0467 9.0147C19.5531 7.72543 17.5731 7.1838 15.6499 7.53698C15.3687 7.59217 15.5719 8.4649 15.8047 8.4183C17.4719 8.11254 19.1875 8.58181 20.4811 9.69899C20.6591 9.85677 21.2623 9.20601 21.0467 9.0147Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1947 8.35654C8.4259 8.40273 8.6307 7.53041 8.3495 7.47522C6.4251 7.12245 4.4463 7.66449 2.9527 8.95294C2.7371 9.14466 3.3403 9.79624 3.5175 9.63723C4.8127 8.52046 6.5275 8.05078 8.1947 8.35654Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9255 11.9255C18.2355 13.2827 15.5019 13.1576 13.9683 11.9264C13.7011 12.1115 13.4823 12.1851 13.5651 12.3486C15.2503 15.5996 18.6431 15.5988 20.3291 12.3486C20.4123 12.1851 20.1935 12.1115 19.9255 11.9255Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4353 12.3486C10.5181 12.1851 10.2993 12.1115 10.0313 11.9255C8.34126 13.2827 5.60766 13.1576 4.07486 11.9264C3.80686 12.1115 3.58726 12.1851 3.67006 12.3486C5.35646 15.5996 8.74926 15.5988 10.4353 12.3486Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4051 17.986H9.59391C9.06831 17.986 9.06831 19.6211 9.59391 19.6211H14.4047C14.9315 19.6211 14.9315 17.986 14.4051 17.986Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContempt);
export default __webpack_public_path__ + "static/media/contempt.c044d9b46235f5b14a0f06d589631167.svg";
export { ForwardRef as ReactComponent };